import { render, staticRenderFns } from "./HubLogo.vue?vue&type=template&id=20ab91b4&scoped=true&"
import script from "./HubLogo.vue?vue&type=script&lang=ts&"
export * from "./HubLogo.vue?vue&type=script&lang=ts&"
import style0 from "./HubLogo.vue?vue&type=style&index=0&id=20ab91b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab91b4",
  null
  
)

export default component.exports